
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { D3WeeklyBarChart } from '@/components/charts/D3ChartUtils';
import { ResizableSwappableCard } from "./ResizableSwappableCard";
import { Skeleton } from "@/components/ui/skeleton";
import { LayoutItem } from './constants';

interface WeeklyUserGrowthChartProps {
  weeklyUsersData: { week: string, count: number }[];
  totalNewUsers: number;
  rearrangingEnabled: boolean;
  onRemove?: (id: string) => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  onResize?: (id: string, newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
}

export function WeeklyUserGrowthChart({
  weeklyUsersData = [],
  totalNewUsers = 0,
  rearrangingEnabled,
  onRemove,
  size = 'medium',
  onResize
}: WeeklyUserGrowthChartProps) {
  const isMediumOrLarger = size === 'medium' || size === 'large' || size === 'xlarge';
  const chartHeight = isMediumOrLarger ? 300 : 200;
  const chartWidth = size === 'small' ? 250 : (size === 'medium' ? 500 : (size === 'large' ? 700 : 900));

  return (
    <ResizableSwappableCard
      id="weekly-user-growth"
      size={size}
      showHandle={rearrangingEnabled}
      showResizeControl={rearrangingEnabled}
      onRemove={rearrangingEnabled ? onRemove : undefined}
      onResize={onResize ? (newSize) => onResize("weekly-user-growth", newSize) : undefined}
    >
      <Card className="h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-medium flex justify-between items-center">
            <span>Weekly User Registrations ({new Date().getFullYear()})</span>
            <span className="text-sm bg-green-100 text-green-800 py-1 px-2 rounded-full">
              Total: {totalNewUsers}
            </span>
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-2">
          {weeklyUsersData.length === 0 ? (
            <div className="w-full flex flex-col gap-2">
              <Skeleton className="h-[250px] w-full rounded-md" />
            </div>
          ) : (
            <div className="flex justify-center items-center overflow-hidden">
              <D3WeeklyBarChart 
                data={weeklyUsersData} 
                width={chartWidth} 
                height={chartHeight} 
              />
            </div>
          )}
        </CardContent>
      </Card>
    </ResizableSwappableCard>
  );
}
